import React, { useState, useContext } from 'react';
import LoadingContext from '../context/loading.context';
import UserDetailsContext from '../context/userDetails.context';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Spinner from './Spinner.component';
import * as Constants from '../modules/constants';

function UserInvitationDialog(props) {

    const { showLoading, hideLoading } = useContext(LoadingContext);
    const { token, email: currentUserEmail } = useContext(UserDetailsContext);

    const [email, setEmail] = useState('');
    const [confirmEmail, setConfirmEmail] = useState('');
    const [authorization, setAuthorization] = useState('Operate');
    const [validated, setValidated] = useState(false);
    const [buttonsEnabled, setButtonsEnabled] = useState(true);

    const confirmEmailRef = React.createRef();

    const apiHostName = Constants.API_URL;

    function clearFields() {
        setEmail('');
        setConfirmEmail('');
        setValidated(false);
        setButtonsEnabled(true);
    }

    function showMessage(message) {
        alert(message);
    }

    function handleSubmit(event) {

        event.preventDefault();

        // Check form validation
        const form = event.currentTarget;
        setButtonsEnabled(false);
        //setRegisterError('');
        setValidated(true);

        confirmEmailRef.current.setCustomValidity(email.toUpperCase() === confirmEmail.toUpperCase() ? '' : "E-mail addresses don't match.");

        if (form.checkValidity() === false) {
            // Invalid form, so stop processing
            event.stopPropagation();
            setButtonsEnabled(true);
            return;
        }

        // Check if this user was not already invited...
        var duplicate = false;
        Object.values(props.invitations).forEach(invitation => invitation.email.toUpperCase() === email.toUpperCase() ? duplicate = true : null);
        if (duplicate) {
            alert('This user is already invited.');
            setButtonsEnabled(true);
            return;
        }
        // ...and that the user is not already a registered user:
        Object.values(props.users).forEach(user => user.email.toUpperCase() === email.toUpperCase() ? duplicate = true : null);
        if (duplicate) {
            alert('This user is already authorized for this location.');
            setButtonsEnabled(true);
            return;
        }

        ///...and that it's not the current user's e-mail address:
        if (currentUserEmail.toUpperCase() === email.toUpperCase()) {
            alert('Do not enter your own e-mail address...');
            setButtonsEnabled(true);
            return;
        }

        // Ask server to send invitation:
        showLoading();
        fetch(apiHostName + '/v1/invitations/' + props.location.id, {
            mode: "cors",
            method: 'POST',
            cache: "no-cache",
            headers: {
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ Email: email, Authorization: authorization })
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('Network error');
                }
                return response.json();
            })
            .then((result) => {
                // Result contains "Ok"
                // Once successful, update the invitations to reflect the added invitation:
                props.setInvitations(prevState => {
                    return { ...prevState, [result.id]: result };
                });
                hideLoading();
                props.onHide();
                showMessage('Invitation has been sent by e-mail.');
            })
            .catch(function (error) {
                // Set visual cue and error text to be displayed on registration screen
                console.error("Cannot create invitation for location...");
                console.error(error);
                showMessage('Network error.');
                hideLoading();
                setButtonsEnabled(true);
            });

    }

    function setEmailText(value) {
        setEmail(value);
        confirmEmailRef.current.setCustomValidity(value === confirmEmail ? '' : "E-mail addresses don't match.");
    }
    function setConfirmEmailText(value) {
        setConfirmEmail(value);
        confirmEmailRef.current.setCustomValidity(value === email ? '' : "E-mail addresses don't match.");
    }

    return (
        <Modal show={props.show} onShow={clearFields} onHide={props.onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Invite user for location '{props.location.name}'</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form noValidate validated={validated} onSubmit={(event) => { handleSubmit(event); }}>
                    <Form.Group style={{ display: 'block' }}>
                        <Form.Label>E-mail address</Form.Label>
                        <Form.Control type="email" name="email" placeholder="E-mail address" value={email} onChange={(e) => { setEmailText(e.target.value); }} required />
                        <Form.Control.Feedback type="invalid">
                            Please enter a valid e-mail address.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group style={{ display: 'block' }}>
                        <Form.Label>Confirm e-mail address</Form.Label>
                        <Form.Control type="text" name="confirmEmail" placeholder="Confirm e-mail address" ref={confirmEmailRef} value={confirmEmail} onChange={(e) => { setConfirmEmailText(e.target.value); }} required />
                        <Form.Control.Feedback type="invalid">
                            Please enter the same e-mail address.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group style={{ display: 'block' }}>
                        <Form.Label>Authorization</Form.Label>
                        <Form.Control as="select" value={authorization} onChange={(e) => setAuthorization(e.target.value)} required>
                            <option>Operate</option>
                            <option>Manage</option>
                        </Form.Control>
                    </Form.Group>

                    <Form.Group style={{ justifyContent: 'flex-end' }}>
                        <Button type="submit" disabled={!buttonsEnabled} style={{ marginRight: '5px' }}>Invite user <Spinner /></Button>
                        <Button disabled={!buttonsEnabled} onClick={props.onHide}>Cancel</Button>
                    </Form.Group>
                </Form>


            </Modal.Body>
            <Modal.Footer>
                <div className='text-muted'>Person doesn't have to be an existing user.</div>
            </Modal.Footer>
        </Modal>
    );
}

export default UserInvitationDialog;


// WEBPACK FOOTER //
// ./src/components/UserInvitationDialog.js